import { escapeRegExp } from 'lodash';
import { InMemoryBackend, InMemoryBackendParams } from '../../InMemoryBackend';
import { KanbanFilters } from './kanbanFilter';
import { MockCard } from './kanban';
import { kanbanStaticLoadMoreCardsData } from './kanbanStaticData';

export function createKanbanItem(
  chance: Chance.Chance,
  {
    createdAt = chance.date({
      min: new Date(Date.now() - 365 * 24 * 60 * 60 * 1000),
      max: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000),
    }) as Date,
    ...rest
  }: Partial<MockCard> = {},
): MockCard {
  return {
    id: chance.guid(),
    name: chance.name(),
    description: chance.sentence(),
    price: chance.integer({ min: 0, max: 10000 }),
    status: chance.pickone(['available', 'outOfStock']),
    createdAt,
    updatedAt: createdAt,
    stageId: chance.guid(),
    ...rest,
  };
}

export const createKanbanItemsBackend = ({
  createOne,
  ...params
}: Partial<InMemoryBackendParams<MockCard, KanbanFilters>> = {}) => {
  return new InMemoryBackend<MockCard, KanbanFilters>({
    enableTotal: params?.enableTotal,
    createOne: (i) => {
      const raw = kanbanStaticLoadMoreCardsData[i];
      return {
        ...raw,
        createdAt: new Date(raw.createdAt ?? ''),
        updatedAt: new Date(raw.updatedAt ?? ''),
      };
    },
    itemKey: (item) => item.id,
    total: 0,
    predicate: (query) => {
      const { search } = query;
      const filters = query.filters ?? {};
      const rgx = new RegExp(escapeRegExp(search), 'i');

      return (item: MockCard) => {
        if (search && !rgx.test(item.name)) {
          return false;
        }

        if (
          filters.stageId &&
          filters.stageId.length &&
          filters.stageId.indexOf(item.id) === -1
        ) {
          return false;
        }

        return true;
      };
    },
    orderBy: (query) => {
      return [...(query.sort ?? [])];
    },
    ...params,
  });
};
